<script lang="ts">
	import { Models as M } from "@lux-ai/api-interface"
	import { getLuxAiController } from "../../LuxAIController.svelte"
	import ActiveGenerationPreview from "./ActiveGenerationPreview.svelte"

	interface Props {
		activeGenerations: Array<M.ThemeGeneration>
	}

	let { activeGenerations }: Props = $props()

	const controller = getLuxAiController()

	function getThemeFromGeneration(generation: M.ThemeGeneration) {
		return controller.availableThemes.find((theme) => theme.id === generation.theme_id)
	}
</script>

<div class="active-generations">
	{#each activeGenerations as generation}
		{@const genTheme = getThemeFromGeneration(generation)}
		{#if genTheme}
			<ActiveGenerationPreview {generation} theme={genTheme} />
		{/if}
	{/each}
</div>

<style>
	.active-generations {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
		margin-bottom: 1rem;
	}
</style>
